import { makeAutoObservable, runInAction } from 'mobx'
import agent from '../api/agent'
import type { UserFirearmDto } from '../models/gunVault'

export default class GunVaultStore {
  items: UserFirearmDto[] = []
  loading = false

  constructor () {
    makeAutoObservable(this)
  }

  get pinnedItems () {
    return this.items.filter((i) => i.isPinned)
  }

  get unpinnedItems () {
    return this.items.filter((i) => !i.isPinned)
  }

  isInVault = (firearmModelId: string) =>
    this.items.some((i) => i.firearmModelId === firearmModelId)

  loadVault = async () => {
    this.loading = true
    try {
      const data = await agent.GunVault.list()
      runInAction(() => {
        this.items = data
        this.loading = false
      })
    } catch (error) {
      runInAction(() => (this.loading = false))
    }
  }

  addFirearm = async (firearmModelId: string, notes?: string) => {
    this.loading = true
    try {
      const entry = await agent.GunVault.add(firearmModelId, notes)
      runInAction(() => {
        this.items = [entry, ...this.items]
        this.loading = false
      })
    } catch (error) {
      runInAction(() => (this.loading = false))
      throw error
    }
  }

  removeFirearm = async (id: string) => {
    this.loading = true
    try {
      await agent.GunVault.remove(id)
      runInAction(() => {
        this.items = this.items.filter((i) => i.id !== id)
        this.loading = false
      })
    } catch (error) {
      runInAction(() => (this.loading = false))
      throw error
    }
  }

  togglePin = async (id: string) => {
    const item = this.items.find((i) => i.id === id)
    if (!item) return
    const pinned = !item.isPinned
    runInAction(() => {
      this.items = this.items.map((i) =>
        i.id === id ? { ...i, isPinned: pinned } : i
      )
    })
    try {
      await agent.GunVault.pin(id, pinned)
    } catch (error) {
      runInAction(() => {
        this.items = this.items.map((i) =>
          i.id === id ? { ...i, isPinned: !pinned } : i
        )
      })
      throw error
    }
  }
}
